import { IExistingRegistration } from '@nkr/models/index';
import { CityValidation } from './city-validation';

export interface IValidation {
    center: boolean,
    micrositeTypeId: boolean,
    confirmShortCode: boolean,
    coordinatorContactId: boolean,
    email: boolean,
    secondaryEmail: boolean,
    firstName: boolean,
    lastName: boolean,
    addressLine1: boolean,
    city: CityValidation,
    stateId: boolean,
    postalCode: boolean,
    birthdate: boolean,
    genderId: boolean,
    guardianFirstName: boolean,
    guardianLastName: boolean,
    guardianEmail: boolean,
    guardianPhone: boolean,
    isVeteran: boolean,
    branchOfService: boolean,
    phonePrimary: boolean,
    phoneSecondary: boolean,
    championName: boolean,
    championEmail: boolean,
    championPhone: boolean,
    existingList: IExistingRegistration[]
}

export const initialValidation: IValidation = {
    center: true,
    micrositeTypeId: true,
    confirmShortCode: true,
    coordinatorContactId: true,
    email: true,
    secondaryEmail: true,
    firstName: true,
    lastName: true,
    addressLine1: true,
    city: CityValidation.Valid,
    stateId: true,
    postalCode: true,
    birthdate: true,
    genderId: true,
    guardianFirstName: true,
    guardianLastName: true,
    guardianEmail: true,
    guardianPhone: true,
    isVeteran: true,
    branchOfService: true,
    phonePrimary: true,
    phoneSecondary: true,
    championName: true,
    championEmail: true,
    championPhone: true,
    existingList: []
};